// extracted by mini-css-extract-plugin
export default {"hidden":"CnF34L","container":"K9Q7bH","controls-showed":"xoV4E0","controlsShowed":"xoV4E0"};